import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactSearchResponse } from '../../models/civi-crm/contact/contact-search/contact-search-response';
import { ContactSearchRequest } from '../../models/civi-crm/contact/contact-search/contact-search-request';
import { CiviCRMContactStatusEnum } from '../../models/civi-crm/contact/civi-crm-contact-status-enum';

@Injectable({
    providedIn: 'root',
})
export class ContactService {
    private readonly baseUrl = 'api/Contacts';

    constructor(private readonly http: HttpClient) {}

    searchContacts(
        contactSearch: ContactSearchRequest,
    ): Observable<ContactSearchResponse[]> {
        return this.http.post<ContactSearchResponse[]>(
            `${this.baseUrl}/search`,
            contactSearch,
        );
    }

    getContactStatus(contactId: number): Observable<CiviCRMContactStatusEnum> {
        return this.http.get<CiviCRMContactStatusEnum>(
            `${this.baseUrl}/${contactId}/status`,
        );
    }
}
